import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import LanguageChip from '../LanguageChip';
import { globalStyles as styles } from '../style/gstheme';
import TitledPanel from '../TitledPanel';
import { DEFAULT_LANG } from '../utils/constants';
import { getAllOrderedLanguages } from '../utils/utils';

const langs = getAllOrderedLanguages(DEFAULT_LANG);

class MultiLanguageSelector extends Component {

  render() {

    const { lang, defaultLang, onSelectAdditionalLang } = this.props;

    return (
      <React.Fragment>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <TitledPanel dataTest="available-languages" title="Available Languages" >
              <div style={{ height: '210px', overflowX: 'hidden', overflowY: 'scroll'  }}>
                {langs
                  .filter(item => !lang.includes(item.code) && item.code !== defaultLang)
                  .map((item) =>
                    <LanguageChip key={"chip-lang-" + item.code} lang={item.code} defaultLang={defaultLang}
                      onClick={() => onSelectAdditionalLang(item.code)} />
                  )}
              </div>
            </TitledPanel>
          </Grid>
          <Grid item xs={6}>
            <TitledPanel dataTest="selected-languages" title="Selected Languages">
              <div style={{ height: '210px', overflowX: 'hidden', overflowY: 'scroll'  }}>
                {langs
                  .filter(item => lang.includes(item.code) && item.code !== defaultLang)
                  .map((item) =>
                    <LanguageChip key={"chip-lang-" + item.code} lang={item.code} defaultLang={defaultLang}
                      onDelete={() => onSelectAdditionalLang(item.code)} />
                  )}
              </div>
            </TitledPanel>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

MultiLanguageSelector.propTypes = {
  classes: PropTypes.object.isRequired,
  onSelectAdditionalLang: PropTypes.func.isRequired,
  lang: PropTypes.array.isRequired,
  defaultLang: PropTypes.string.isRequired
};

export default withStyles(styles)(MultiLanguageSelector);